import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { EnhancedTable as AggregateTable } from './aggregateTable'
import SelectionAggregation from './selectionAggregation'
import LoadingDialog from './loadingDialog'
import { toggledWorkflowAggregateAccordion } from '../../../../store/pages/common/workflow'

const StyledGrid = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(2),
  width: '100%',
  height: 'max-content'
}))

const Table = styled(AggregateTable)(({ theme }) => ({
  padding: theme.spacing(2),
  overflow: 'visible',
  minHeight: 400
}))

function Aggregate (props) {
  const [open, setOpen] = React.useState(false)
  const dispatch = useDispatch();

  const project = useSelector((state) => state.project);

  const handleAccordionChange = (accordionId) => () => {
    dispatch(
      {
        ...toggledWorkflowAggregateAccordion,
        payload: {
          accordionId,
          index: props.order,
          expanded: !props.state.state.accordion[accordionId].expanded
        }
      })
  };

  return (
    <Grid width="100%" container >
      <LoadingDialog handleClose={setOpen} open={open} id={project.id} state={props.state} />
      <StyledGrid item container xs={12} spacing={2}>
        <Grid item xs={5} width="45%">
          <Accordion width="100%" expanded={props.state.state.accordion.fields.expanded} onChange={handleAccordionChange('fields')}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
            >
              <Typography>Fields </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Table state={props.state} order={props.order} />
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item xs={6} width="45%">
          <Accordion width="100%" expanded={props.state.state.accordion.aggregation.expanded} onChange={handleAccordionChange('aggregation')}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
            >
              <Typography> Aggregation </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <SelectionAggregation state={props.state} order={props.order} />
            </AccordionDetails>
          </Accordion>
        </Grid>

      </StyledGrid>
    </Grid>
  )
}

export default React.memo(Aggregate)
